import SearchString from './SearchString.svelte'

export const commonComponents = [
    [SearchString, "node-search-string"],
]
